import styled from "styled-components";

export const WeeksContainer = styled.div`
  margin: 8px auto;
  padding: 16px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const WeekTitle = styled.p`
  margin-bottom: 16px;
  font-size: 14px;
  color: #000;
`;
export const WeeksSummaryAligner = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const WeeksSummaryBox = styled.div`
  padding: 8px;
  min-width: 131px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 2px;
  background-color: rgba(242, 242, 242, 0.95);
`;
export const DataNumber = styled.p`
  color: #000;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
`;
export const ActivityTypeText = styled.p`
  color: ${({ color }) => color && color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const DataType = styled.p`
  color: #000;
  font-size: 14px;
`;
export const ActionButtonsDiv = styled.div`
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const EditButton = styled.button`
  padding: 8px 16px;
  width: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 2px solid #c1272d;
  background: transparent;
  color: #c1272d;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const AcceptButton = styled.button`
  display: flex;
  width: 190px;
  height: 33px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: none;
  border-radius: 4px;
  background-color: #26a9b6;
  box-shadow: 0px 1px 0px 0px #1c7983;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const AcceptedTextDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;
export const CheckImg = styled.img`
  display: flex;
  align-items: center;
  gap: 2px;
`;
export const AcceptedText = styled.p`
  color: #808080;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
`;
